<div class="input-group mb-4" *ngIf="control">
  <input 
    [id]="inputId" 
    [type]="inputType"
    class="form-control"
    [ngClass]="{
      'is-invalid': isInvalid, 
      'populated': control.value
    }"
    [autocomplete]="autocomplete" 
    [maxLength]="maxLength"
    [formControl]="control"
    (keyup)="onKeyup($event)"
    (change)="onChange($event)" 
    (focusout)="onFocusout($event)"
    (blur)="onBlur($event)"
    [trim]="trim" 
    [placeholder]="placeholder"
    [attr.disabled]="isDisabled ? true : null"
    />
  <label [for]="inputId" class="placeholder font-size-primary">
    {{ label }} 
    <ng-container *ngIf="required">*</ng-container>
    <ng-container *ngIf="!required && optionalTag">{{ 'public.global.optional' | translate }}</ng-container>
  </label>
  <div class="invalid-feedback font-size-secondary" *ngIf="isInvalid && errorText?.trim()">
      <span>{{ errorText }}</span>
  </div>
</div>